import React from 'react';

const HomePage = () => {
    return <div>这是首页内容</div>;
};

export default HomePage;
